module.exports = __webpack_public_path__ + "img/父亲拿包.513c665c.png";